<template>
    <LazyHydrate when-visible>
        <component :is="pagePart && pagePart.componentName" :items="pagePart && pagePart.componentItems" :componentContent="pagePart && pagePart.componentContent" :items-count="pagePart && pagePart.items_count" :settings="pagePart && pagePart.settings"/>
    </LazyHydrate>
</template>

<script>
export default {
    name: "SinglePagePart",

    props: ['pagePart'],
}
</script>